<template>
    <div class="notification">
        <div class="notification__item notification__item--header">
            <div class="d-flex">
                <div class="d-flex w-100 h-100 p-3">
                    <button class="btn btn-sm rounded-pill shadow-none" :class="unread ? 'btn-primary': ''" @click.prevent="unreadNotification">{{ notifications?.data?.length }} {{ $t('new') }}</button>
                    <button class="btn btn-sm rounded-pill shadow-none" :class="unread ? '': 'btn-primary'" @click.prevent="markAsRead">{{ $t('mark_all_as_read') }}</button>
                </div>
            </div>
        </div>
        <div class="notification__item notification__item--body custom-scrollbar scroll-y">
            <app-pre-loader v-if="loading" />
            <template v-else>
                <div class="dropdown-items-wrapper custom-scrollbar">
                    <app-empty-data-block v-if="!notifications.data.length" :message="$t('empty_data_block_notification')"/>
                    <template v-else>
                        <transition-group name="list" tag="div">
                            <notification-item v-for="(item, index) in notifications.data" :item="item" :key="`notification-item-${index}-${item.id}`"/>
                        </transition-group>
                    </template>
                </div>
            </template>
        </div>
        <div class="notification__item notification__item--footer">
            <a class="dropdown-item text-primary text-center h-100 d-flex justify-content-center align-items-center" :href="allNotificationUrl">{{ $t('see_all') }}</a>
        </div>
    </div>
</template>

<script>
import NotificationItem from "./NotificationItem";
import {mapGetters} from 'vuex'
import {axiosPost, urlGenerator} from "../../../../../helpers/AxiosHelper";
import {NOTIFICATIONS} from "../../../../../config/ApiUrl";
export default {
    components: {NotificationItem},
    data() {
        return {
            unread: true,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'ClientNotifications/loading',
            list: 'ClientNotifications/list',
            notifications: 'getFormattedNotifications',
        }),
        allNotificationUrl() {
            return urlGenerator('/notification/list')
        },
        unreadNotificationUrl() {
            return `${this.allNotificationUrl}?unread=1`
        }
    },
    methods: {
        markAsRead() {
            // this.loading = true;
            axiosPost(`${NOTIFICATIONS}/mark-all-as-read`, {}).then(({data}) => {
                this.$store.dispatch('getNotifications');
                this.$store.dispatch('setNotificationEmpty');
                this.$toastr.s(data.message);
            }).finally(() => {
                // this.loading = false;
            })
        },
        unreadNotification() {
            window.location = this.unreadNotificationUrl;
        }
    }
}
</script>

<style scoped lang="scss">
.notification {
    height: 100%;
    position: relative;
    &__item {
        width: 100%;

        &--header {
            height: 50px;
            position: absolute;
            top: 0;
        }

        &--body {
            position: absolute;
            top: 50px;
            bottom: 40px;
        }

        &--footer {
            position: absolute;
            bottom: 0;
            height: 40px;
        }
    }
}

.list-enter-active,
.list-leave-active {
    transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

</style>